import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
//import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';
import FMPCheckbox from "../pureForm/FMPCheckbox";
import FMPText from "../pureForm/FMPText";

const styles = (theme) => ({
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question : {
		padding: '20px 20px 10px 20px',
		fontWeight : 600,
		fontSize : 16,
		textAlign : 'right',
	},
	actions : {
		padding : 10,
	},
	warningButton : {
		borderRadius : 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
});


class ConfirmCancelDeliveryDialog extends Component {

	constructor (props) {
		super(props);
		this.state = {
			cancellationReason : '',
			doNotEmailStationCancellation : false,
		};
	}

	handlePureChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	};

	getInputProps = (path, md, defaultValue) => {
		return {
			path,
			value  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.handlePureChange,
			md : md || 6,
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		const val = _.get(this.state, path, _d);
		return (_.isNull(val)) ? '' : val;
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleCancelDelivery = () => {
		const {
			cancelDelivery,
			onClose,
			stationDelivery,
			bulkDelivery,
			showErrors
		} = this.props;
		const { cancellationReason, doNotEmailStationCancellation } = this.state;

		if (!cancellationReason) {
			showErrors(['A cancellation reason is required.']);
			return;
		}

		const params = {
			cancellationReason,
			doNotEmailStationCancellation,
		};

		if (stationDelivery) {
			params.stationDeliveryId = stationDelivery.stationDeliveryId;
		} else if (bulkDelivery) {
			params.bulkDeliveryId = bulkDelivery.bulkDeliveryId;

		} else {
			return showErrors(['Missing e85 or bulk delivery']);
		}

		cancelDelivery({
			params,
			callback : (err) => {
				if (!err) { onClose(); }
			}
		});
	};

	render() {
		const { classes, open, stationDelivery } = this.props;
		return (
			<Dialog
				maxWidth='md'
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<DialogTitle>Cancel Delivery</DialogTitle>
				<DialogContent>
					<FMPText
						{...this.getInputProps(`cancellationReason`)}
						label={'Reason for cancelling delivery'}
					/>

					{stationDelivery &&
					<FMPCheckbox
						{...this.getInputProps(`doNotEmailStationCancellation`)}
						label={'Do not email station about cancellation.'}
						value={`doNotEmailStationCancellation`}
					/>
					}

				</DialogContent>

				<div className={classes.question}>
					Are you sure you want to cancel this delivery?
				</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>
							Close
						</Button>
						<Button
							variant="contained"
							onClick={this.handleCancelDelivery}
							className={classes.warningButton}
						>
							Yes, cancel delivery
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmCancelDeliveryDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,

	//- Could be either
	stationDelivery : PropTypes.object,
	bulkDelivery : PropTypes.object,

	cancelDelivery : PropTypes.func.isRequired,
	showErrors : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ConfirmCancelDeliveryDialog);